'use client';
import { InternalLinkIcon, EmailIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useState, useEffect, useId } from 'react';
import { ActionIndicator } from '../../Buttons/ActionIndicator/ActionIndicator.mjs';
import { factory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import { omitText } from '../../utils/helpers.mjs';
import { Popover } from '../subcomponents/Popover/Popover.mjs';
import classes from './SharePopover.module.css.mjs';
import { sharePopoverIconMap } from './SharePopover.utils.mjs';

const SharePopover = factory((props, ref) => {
  const {
    target,
    links,
    cartNumberText,
    showDivider = true,
    copyCTA,
    emailCTA,
    className,
    withRoles,
    trapFocus,
    withinPortal,
    mod,
    width,
    autoCloseOnParentHoverOut,
    isParentHovered,
    ...rest
  } = props;
  const [dropdownOpened, setDropdownOpened] = useState(false);
  useEffect(() => {
    if (autoCloseOnParentHoverOut && !isParentHovered && dropdownOpened) {
      setDropdownOpened(false);
    }
  }, [autoCloseOnParentHoverOut, isParentHovered, dropdownOpened]);
  const classNames = clsx(classes.sharePopoverRoot, "kohler-share-popover-root", className);
  const id = useId();
  return /* @__PURE__ */ React.createElement(Box, { className: classNames, ...rest, ref }, /* @__PURE__ */ React.createElement(
    Popover,
    {
      opened: dropdownOpened,
      trapFocus: trapFocus || false,
      position: "bottom-end",
      withinPortal: withinPortal || false,
      withRoles: withRoles || false,
      withArrow: false,
      id,
      onChange: setDropdownOpened
    },
    /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement(
      Box,
      {
        component: "button",
        type: "button",
        onClick: () => {
          setDropdownOpened((c) => !c);
        },
        className: "kohler-share-popover-target"
      },
      target
    )),
    /* @__PURE__ */ React.createElement(
      Popover.Dropdown,
      {
        onMouseDown: (event) => event.preventDefault(),
        className: clsx(classes.sharePopoverWrapper, "kohler-share-popover-wrapper"),
        mod
      },
      /* @__PURE__ */ React.createElement(Box, { className: classes.sharePopoverContent, width }, links && /* @__PURE__ */ React.createElement("div", { className: classes.sharePopoverLinksContainer }, links.map(({ logo, ...rest2 }) => {
        const IconComponent = sharePopoverIconMap[logo];
        if (!IconComponent) return null;
        return /* @__PURE__ */ React.createElement(
          Box,
          {
            component: "a",
            className: classes.sharePopoverLink,
            textColor: "var(--content-tertiary)",
            target: "_blank",
            key: `${rest2.href}-${logo}`,
            ...rest2
          },
          /* @__PURE__ */ React.createElement(IconComponent, { withBoundingBox: false })
        );
      })), cartNumberText && /* @__PURE__ */ React.createElement(
        Typography,
        {
          className: classes.sharePopoverCartNumber,
          textColor: "var(--content-tertiary)",
          size: "label-medium-s",
          component: "p",
          ...omitText(cartNumberText)
        },
        cartNumberText.text
      ), showDivider && /* @__PURE__ */ React.createElement("div", { className: classes.sharePopoverDivider }), (copyCTA || emailCTA) && /* @__PURE__ */ React.createElement("div", { className: classes.sharePopoverActionsContainer }, copyCTA && /* @__PURE__ */ React.createElement(ActionIndicator, { icon: InternalLinkIcon, label: "Copy link", ...copyCTA }), emailCTA && /* @__PURE__ */ React.createElement(ActionIndicator, { icon: EmailIcon, label: "Email", ...emailCTA })))
    )
  ));
});

export { SharePopover };
